import * as Yup from "yup";

const Validation = Yup.object({
  code: Yup.string()
    .trim()
    .matches(
      /^[A-Z0-9-_]+$/,
      "Code must contain only A-Z, 0-9, '-' or '_' and no spaces"
    )
    .required("Please enter promo code!"),

  discountValue: Yup.number()
    .typeError("Discount value must be a number")
    .min(0, "Discount value cannot be negative")
    .required("Please enter discount value!"),

  discountType: Yup.string()
    .oneOf(
      ["percentage", "fixed"],
      "Discount type must be 'percentage' or 'fixed'"
    )
    .required("Please select discount type!"),

  validityDays: Yup.number()
    .typeError("Validity days must be a number")
    .min(0, "Validity days cannot be negative")
    .required("Please enter validity days!"),

  maxUsage: Yup.number()
    .typeError("Max usage per user must be a number")
    .min(0, "Validity days cannot be negative")
    .required("Please enter max usage per user!"),
});

export default Validation;
